module.exports = __webpack_public_path__ + "assets/images/novasport_2.f3eff47233e37ee14f957c64b1cac3a6.png";